export default {
  name: 'en',
  ep: {
    dialog: {
      cancel: 'Cancel',
      confirm: 'OK',
      title: 'Prompt',
    },
    buttons: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      secondConfirm: 'Are you sure to',
      secondConfirmEnd: '',
      prompt: 'prompt',
    },
    input: {
      placeholder: 'Please enter',
    },
    datePickerRange: {
      lastWeek: 'Last week',
      lastMonth: 'Last month',
      lastThreeMonth: 'Last three months',
      startTime: 'Start time',
      endTime: 'End time',
    },
    formItem: {
      required: 'Cannot be empty',
    },
    form: {
      more: 'More',
      collapse: 'Collapse',
    },
    header: {
      save: 'Save',
      edit: 'Edit',
      cancel: 'Cancel',
      refresh: 'Refresh',
      approvalLog: 'Approval log',
    },
    searchListPage: {
      add: 'Add',
      templateDownload: 'Template download',
      import: 'Import',
      export: 'Export',
      search: 'Search',
      clear: 'Clear',
    },
    table: {
      select: 'Select',
      serialNumber: 'No.',
      operation: 'Operation',
    },
    title: {
      collapse: 'Collapse',
      expand: 'Expand',
    },
    chooseDialog: {
      selected: 'Selected',
      unit: '',
    },
    customColumn: {
      columnSettings: 'Column settings',
      defineColumn: 'Define column',
      hiddenField: 'Hidden field',
      visibleField: 'Display field',
      moveLeft: 'Move left',
      moveRight: 'Move right',
      moveUp: 'Move up',
      moveDown: 'Move down',
    },
    bpm: {
      approvalLog: 'Approval log',
    },
    loading: {
      loading: 'Loading...',
    },
    http: {
      networkError: 'Network error, please check your connection and try again',
      timeout: 'Request timeout, please try again later',
      requestError: 'Request error. Please check your input and try again',
      authExpired: 'Login authentication expired, please log in again',
      forbidden:
        'Access forbidden, you do not have permission to access this resource',
      notFound: 'Not found, the requested resource does not exist',
      serverError: 'Internal server error, please try again later',
    },
    attachment: {
      addAttachment: 'Add attachment',
      manageAttachment: 'Attachment management',
      operation: 'Operation',
      download: 'Download',
      delete: 'Delete',
      attachmentType: 'Attachment type',
      fileName: 'File name',
      creator: 'Creator',
      createTime: 'Create time',
      description: 'Description',
    },
  },
}
